// Generated by CoffeeScript 2.7.0
var ConstText;

import FieldMixins from 'trunks/vue/admin/components/fields/mixins/field_mixin.js';

import BaseField from './field.js';

import SerialNumberFieldMixin from './mixin.js';

export default ConstText = Vue.extend({
  mixins: [FieldMixins, SerialNumberFieldMixin],
  components: {
    FieldView: BaseField
  },
  template: `<FieldView
  ref="fieldView"
  :editing='editing'
  :field="field"
>
  <input
    slot='optionbar'
    placeholder="请输入内容，最多20个字符"
    type="text"
    class="ml-3 const-text-input"
    v-model="field.settings.const_text"
  />
  <template slot='description'>
    <span>在编号中插入固定的自定义字符</span>
  </template>
  <template slot='content'>
    <div>{{ field.settings.const_text }}</div>
  </template>
</FieldView>`
});
